<script>
    import AdminBar from "../../components/AdminBar.svelte";
    import Foot from "../../components/Foot.svelte";
    import {backofficeServiceHost, userRef} from "../../stores/magic-wallet-store";
    import FindBar from "../../components/FindBar.svelte";

    let myUserRef
    let gameId

    let gameRounds

    const searchByUserRef = async () => {
        if (myUserRef && myUserRef.length > 0 && gameId && gameId.length > 0) {
            userRef.set(myUserRef)
            gameRounds = ((await (await fetch(`${backofficeServiceHost}/gameRounds?userRef=${myUserRef}&&gameId=${gameId}`)).json()))
            console.log(gameRounds)
        }
    }

    userRef.subscribe(value => {
        if (value && value.length > 0) {
            myUserRef = value
            searchByUserRef()
        }
    })

</script>

<AdminBar/>
<main>
    <section class="introduction-section">
        <h1>Game Rounds</h1>
        <FindBar labelText="Goosicorn UserRef" bind:criteria={myUserRef} labelText2="GameId" bind:criteria2={gameId} searchFunction={searchByUserRef}/>
    </section>
</main>
<Foot/>
<style>
    main {
        width: 98%;
        margin: 10px auto;
    }

    .introduction-section {
        width: 100%;
    }
</style>
